import { ArrowDownIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Alert,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertIcon,
  Badge,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  IconButton,
  Image,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { appointmentRepository } from 'api/appointmentRepository';
import { CertificateRepository } from 'api/CertificateRepository';
import Card from 'components/card/Card';
import { useAuth } from 'contexts/authContext';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RescheduleAppointment from './RescheduleAppointment';
export default function AppointmentDetailPage() {
  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const bgColor = useColorModeValue('blue.50', 'gray.700');
  const subTextColor = useColorModeValue('gray.800', 'gray.100');
  const { role } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [Appointment, setAppointment] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState<Record<string, boolean>>({});
  const [pdfPreviews, setPdfPreviews] = useState<{ [key: string]: string }>({});
  const [csvPreviews, setCsvPreviews] = useState<{ [key: string]: string[][] }>({});
  const [imagePreviews, setImagePreviews] = useState<{ [key: string]: string }>({});


  // New certificate state
  const [certificateObj, setCertificateObj] = useState<any | null>(null);
  const [certLoading, setCertLoading] = useState(false);
  const [isCloseDialogOpen, setIsCloseDialogOpen] = useState(false);
  const [isReopenDialogOpen, setIsReopenDialogOpen] = useState(false);
  const hasCertificate = certificateObj &&
    Array.isArray(certificateObj.certificates) &&
    certificateObj.certificates.length > 0;
  const [isRescheduleOpen, setIsRescheduleOpen] = useState(false);
  const appointmentId = location.state?.appointmentId
  const [centerAlertVisible, setCenterAlertVisible] = useState(false);
  const [centerAlertMessage, setCenterAlertMessage] = useState('');
  const [centerAlertStatus, setCenterAlertStatus] = useState<
    'success' | 'info' | 'warning' | 'error'
  >('success');
  const centerAlertTimerRef = useRef<number | null>(null);
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  const showCenteredAlert = (
    msg: string,
    status: 'success' | 'info' | 'warning' | 'error' = 'success'
  ) => {
    if (centerAlertTimerRef.current) {
      window.clearTimeout(centerAlertTimerRef.current);
      centerAlertTimerRef.current = null;
    }
    setCenterAlertMessage(msg);
    setCenterAlertStatus(status);
    setCenterAlertVisible(true);
    centerAlertTimerRef.current = window.setTimeout(() => {
      setCenterAlertVisible(false);
      centerAlertTimerRef.current = null;
    }, 1500);
  };

  const ReuiredType = [
    "Callibration",
    "Tracability",
    "Invoice",
    "ServiceReport",
    "Others",
  ];

  const uploadedTypes =
    certificateObj?.certificates?.map((cert: any) =>
      cert.type?.trim()

    ) || [];

  const pendingCertificates = ReuiredType.filter(
    (type) => !uploadedTypes.includes(type)
  );


  useEffect(() => {
    if (!certificateObj?.certificates) return;

    certificateObj.certificates.forEach((cert: any) => {
      const lower = cert.fileName.toLowerCase();

      if (lower.endsWith(".pdf")) {
        loadPdfPreview(cert.fileUrl, cert.fileName);
      } else if (
        lower.endsWith(".jpg") ||
        lower.endsWith(".jpeg") ||
        lower.endsWith(".png")
      ) {
        loadImagePreview(cert.fileUrl, cert.fileName);
      } else if (lower.endsWith(".csv")) {
        loadCsvPreview(cert.fileUrl, cert.fileName);
      }
    });
  }, [certificateObj]);

  // Download certificate file
  const handleDownload = async (certificateId: string, fileName: string) => {
    try {
      const blob = await CertificateRepository.downloadCertificate(certificateId);
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName || 'certificate';
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      showCenteredAlert(`File "${fileName}" downloaded successfully!`, 'success');
    } catch (error) {
      showCenteredAlert('Download failed. Please try again.', 'error');
    }
  };

  const loadPdfPreview = async (certificateId: string, fileName: string) => {
    if (pdfPreviews[fileName]) return;

    try {
      const blob = await CertificateRepository.downloadCertificate(certificateId);
      const blobUrl = URL.createObjectURL(blob);
      setPdfPreviews((prev) => ({ ...prev, [fileName]: blobUrl }));
    } catch (err) {
      showCenteredAlert("PDF preview failed. Please try again.", "error");
    }
  };

  // Fetch CSV for preview 
  const loadCsvPreview = async (certificateId: string, fileName: string) => {
    if (csvPreviews[fileName]) return;

    try {
      const blob = await CertificateRepository.downloadCertificate(certificateId);
      const text = await blob.text();
      const rows = text.split("\n").map((row) => row.split(","));
      const previewRows = rows.slice(0, 5);
      setCsvPreviews((prev) => ({ ...prev, [fileName]: previewRows }));
    } catch (err) {
      showCenteredAlert("CSV preview failed. Please try again.", "error");
    }
  };

  // fetch jpg png preview
  const loadImagePreview = async (fileUrl: string, fileName: string) => {
    if (imagePreviews[fileName]) return;

    try {
      setLoading((prev) => ({ ...prev, [fileName]: true }));
      const blob = await CertificateRepository.downloadCertificate(fileUrl);
      const blobUrl = URL.createObjectURL(blob);
      setImagePreviews((prev) => ({ ...prev, [fileName]: blobUrl }));
    } catch (err) {
      showCenteredAlert("Image preview failed. Please try again.", "error");
    } finally {
      setLoading((prev) => ({ ...prev, [fileName]: false }));
    }
  };
  // Render preview 
  const renderFilePreview = (fileUrl: string, fileName: string) => {
    const lowerName = (fileName || "").toLowerCase();
    if (lowerName.endsWith(".pdf")) {
      const previewUrl = pdfPreviews[fileName];
      return (
        <Box mt={2} w="100%" h="300px" border="1px solid" borderColor={borderColor} borderRadius="8px">
          {previewUrl ? (
            <iframe src={previewUrl} width="100%" height="100%" title={fileName} />
          ) : (
            <Button size="sm" mt={2} onClick={() => loadPdfPreview(fileUrl, fileName)} colorScheme="blue">
              Load PDF Preview
            </Button>
          )}
        </Box>
      );
    }
    if (lowerName.endsWith(".pdf")) {
      const previewUrl = pdfPreviews[fileName];
      return (
        <Box mt={2} w="100%" h="300px" border="1px solid" borderColor={borderColor} borderRadius="8px">
          {previewUrl ? (
            <iframe src={previewUrl} width="100%" height="100%" title={fileName} />
          ) : (
            <Button
              size="sm"
              mt={2}
              onClick={() => loadPdfPreview(certificateObj?.certificateId || "", fileName)}
              colorScheme="blue"
            >
              Load PDF Preview
            </Button>
          )}
        </Box>
      );
    }

    if (
      lowerName.endsWith(".jpg") ||
      lowerName.endsWith(".jpeg") ||
      lowerName.endsWith(".png")
    ) {
      const previewUrl = imagePreviews[fileName];
      const isLoading = loading[fileName];

      return (
        <Box
          mt={2}
          border="1px solid"
          borderColor={borderColor}
          borderRadius="8px"
          p={2}
          textAlign="center"
        >
          {isLoading ? (
            <Spinner size="sm" />
          ) : previewUrl ? (
            <Image src={previewUrl} alt={fileName} maxH="300px" mx="auto" borderRadius="md" />
          ) : (
            <Button
              size="sm"
              mt={2}
              onClick={() => fileUrl && loadImagePreview(fileUrl, fileName)}
              colorScheme="green"
            >
              Load Image Preview
            </Button>
          )}
        </Box>
      );
    }

    if (lowerName.endsWith(".csv")) {
      const previewRows = csvPreviews[fileName];
      return (
        <Box mt={2} border="1px solid" borderColor={borderColor} borderRadius="8px" p={2}>
          {previewRows ? (
            <Table size="sm" variant="striped">
              <Thead>
                <Tr>
                  {previewRows[0].map((cell, i) => (
                    <Th key={i}>{cell}</Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {previewRows.slice(1).map((row, i) => (
                  <Tr key={i}>
                    {row.map((cell, j) => (
                      <Td key={j}>{cell}</Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          ) : (
            <Button
              size="sm"
              mt={2}
              onClick={() => loadCsvPreview(certificateObj?.certificateId || "", fileName)}
              colorScheme="green"
            >
              Load CSV Preview
            </Button>
          )}
        </Box>
      );
    }

    // Unsupported preview
    return (
      <Text mt={2} fontSize="sm" color="gray.500">
        Preview not available for this file type.
      </Text>
    );
  };

  // Fetch appointment
  useEffect(() => {
    let mounted = true;
    setIsLoading(true);

    if (appointmentId) {
      appointmentRepository
        .getappointmentById(appointmentId)
        .then((data) => {
          if (!mounted) return;
          setAppointment(data);
        })
        .catch((error) => {

        }).finally(() => mounted && setIsLoading(false));
    } else {
      setIsLoading(false);
    }

    return () => {
      mounted = false;
    };
  }, [appointmentId]);

  // Fetch certificate by calibrationId
  useEffect(() => {
    if (!Appointment?.calibrationId) return;
    let mounted = true;
    const fetchCert = async () => {
      setCertLoading(true);
      try {
        const data = await CertificateRepository.getCertificatesByCalibrationId(
          Appointment.calibrationId
        );
        if (mounted) setCertificateObj(data || null);
      } catch (err) {
        if (mounted) setCertificateObj(null);
      } finally {
        if (mounted) setCertLoading(false);
      }
    };

    fetchCert();

    return () => {
      mounted = false;
    };
  }, [Appointment]);

  const handleCloseAppointment = async () => {
    try {
      await appointmentRepository.updateAppointmentStatus(
        Appointment.id, "Closed");
      showCenteredAlert("Appointment Closed Successfully", "success");
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (err) {
      showCenteredAlert("Failed to close appointment", "error");
    } finally {
      setIsCloseDialogOpen(false);
    }
  };

  if (isLoading) {
    return (
      <Card mt={{ base: '20px', md: '50px' }} p={6}>
        <Flex align="center" gap={3}>
          <Spinner />
          <Text color={textColor}>Loading appointment details...</Text>
        </Flex>
      </Card>
    );
  }

  const handleReopenAppointment = async () => {
    try {
      await appointmentRepository.reopenAppointment(
        Appointment.id
      );

      showCenteredAlert(
        "Appointment reopened successfully",
        "success"
      );
      // refresh appointment details
      const updated = await appointmentRepository.getappointmentById(
        Appointment.id
      );

      setAppointment(updated);
    } catch (err: any) {
      showCenteredAlert(
        err?.response?.data || "Failed to reopen appointment",
        "error"
      );
    }
  };

  return (
    <Card mt={{ base: '20px', md: '50px' }} p={6}>
      <Flex justify="space-between" align="center" mb={4}>
        <Text fontSize="2xl" fontWeight="bold" color={textColor}>
          Appointment Details
        </Text>
        <Flex justify="flex-end">
          <IconButton
            aria-label="Close"
            icon={<CloseIcon />}
            variant="ghost"
            size="sm"
            onClick={() => navigate('/admin/AppointmentList', { state: location.state })}
          />
        </Flex>
      </Flex>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        p={6}
        bg={bgColor}
        borderColor={borderColor}
      >
        <Flex justify="space-between" align="flex-start" gap={4}>

          {/* Left Content */}
          <Box>
            <Text mb={2} color={subTextColor}>
              <strong>Asset:</strong> {Appointment?.assetName || 'N/A'}
            </Text>

            <Text mb={2} color={subTextColor}>
              <strong>Vendor:</strong> {Appointment?.vendorName || 'N/A'}
            </Text>

            <Text mb={2} color={subTextColor}>
              <strong>Equipment Id:</strong> {Appointment?.assetEquipmentId || 'N/A'}
            </Text>

            <Text mb={2} color={subTextColor}>
              <strong>ScheduleDate :</strong>{' '}
              {Appointment?.scheduledDate
                ? new Date(Appointment?.scheduledDate).toLocaleDateString()
                : 'N/A'}
            </Text>

            <Text mb={2} color={subTextColor}>
              <strong>Modified Date :</strong>{' '}
              {Appointment?.modifiedAt
                ? new Date(Appointment?.modifiedAt).toLocaleDateString()
                : 'N/A'}
            </Text>

            <Text color={subTextColor}>
              <strong>Status:</strong>{' '}
              <Badge
                colorScheme={
                  Appointment?.status === 'Closed'
                    ? 'green'
                    : Appointment?.status === 'Pending'
                      ? 'yellow'
                      : 'red'
                }
                fontSize="0.9em"
                px={2}
                borderRadius="full"
              >
                {Appointment?.status ? Appointment?.status : 'N/A'}
              </Badge>
            </Text>
          </Box>

          {/* Right Side Button */}
          {Appointment?.status === "Closed" && (
            <Button
              colorScheme="green"
              fontSize="md"
              fontWeight="bold"
              borderRadius="16px"
              px={6}
              h="46px"
              // onClick={handleReopenAppointment}
              onClick={() => setIsReopenDialogOpen(true)}
            >
              Reopen
            </Button>
          )}
        </Flex>
      </Box>

      <Divider my={6} borderColor={borderColor} />

      <Flex justify="space-between" align="center" mb={4}>
        <Text fontSize="2xl" fontWeight="bold" color={textColor}>
          Certificate Section
        </Text>

        {(role === 'Vendor' || role === 'Admin' || role === 'OrgAdmin') && !certLoading && Appointment?.status !== 'Closed' && (
          <Button
            variant="solid"
            colorScheme="blue"
            onClick={() => {
              if (Appointment?.calibrationId) {
                navigate('/admin/CertificateListUpload', {
                  state: { id: Appointment.calibrationId },
                });
              } else {
                showCenteredAlert('Calibration ID not found', 'error');
              }
            }}
          >
            Add Certificate
          </Button>
        )}
      </Flex>

      <Box
        borderWidth="1px"
        borderRadius="lg"
        p={6}
        bg={bgColor}
        borderColor={borderColor}
      >
        {certLoading ? (
          <Flex align="center" gap={3}>
            <Spinner /> <Text color={subTextColor}>Loading certificate...</Text>
          </Flex>
        ) : certificateObj ? (
          <>
            <Text mb={2} color={subTextColor}>
              <strong>CalibrationId :</strong> {certificateObj.calibrationId}
            </Text>
            <Text mb={2} color={subTextColor}>
              <strong>Status:</strong> {certificateObj.status}
            </Text>
            <Text mb={2} color={subTextColor}>
              <strong>Uploaded On:</strong>{' '}
              {certificateObj.uploadedAt
                ? new Date(certificateObj.uploadedAt).toLocaleString()
                : 'Not Uploaded'}
            </Text>
            <Text fontWeight="bold" color={subTextColor}>
              Pending Certificate :{" "}
              <Box as="span" color="red.500">
                {pendingCertificates.length > 0
                  ? pendingCertificates.join(", ")
                  : "None"}
              </Box>
            </Text>

            {certificateObj.certificates?.length > 0 && (
              <>
                <Text mt={4} mb={2} fontWeight="bold" color={textColor}>
                  Certificate Files:
                </Text>

                {certificateObj.certificates.map((file: any, idx: number) => (
                  <Box
                    key={idx}
                    p={3}
                    borderWidth="1px"
                    borderRadius="md"
                    mt={3}
                    bg="whiteAlpha.100"
                  >
                    <Flex justify="space-between" align="center">
                      <Text fontWeight="600">{file.fileName}</Text>
                      <Button
                        colorScheme="blue"
                        size="sm"
                        onClick={() => handleDownload(file.fileUrl, file.fileName)}
                      >
                        Download <ArrowDownIcon ml={1} />
                      </Button>
                    </Flex>
                    {renderFilePreview(file.fileUrl, file.fileName)}
                  </Box>
                ))}
              </>
            )}
          </>
        ) : (
          <>
            <Text mb={2} color={subTextColor}>
              <strong>Status:</strong> {Appointment?.status || 'Pending'}
            </Text>
            <Text mb={2} color={subTextColor}>
              <strong>Uploaded On:</strong>{' '}
              {Appointment?.uploadedOn
                ? new Date(Appointment?.uploadedOn).toLocaleString()
                : 'Not Uploaded'}
            </Text>
            <Text mt={2} color={subTextColor}>
              No certificate found for this appointment.
            </Text>
          </>
        )}
      </Box>

      <Divider my={6} borderColor={borderColor} />

      {Appointment?.status !== "Closed" && (
        <Flex justify="center" gap={6}>
          <Button
            variant="darkBrand"
            fontSize="sm"
            borderRadius="16px"
            w={{ base: '128px', md: '148px' }}
            h="46px"
            onClick={() => setIsRescheduleOpen(true)}
          >
            Reschedule
          </Button>

          {/* Appointment Close – only for non-vendor */}
           {(role === 'Admin' || role === 'OrgAdmin') && (
            <Tooltip
              label="Upload at least one certificate to close the appointment"
              placement="top"
              hasArrow
              isDisabled={hasCertificate}
            >
              <span>
                <Button
                  colorScheme="red"
                  fontSize="sm"
                  borderRadius="16px"
                  w={{ base: '128px', md: '148px' }}
                  h="46px"
                  onClick={() => setIsCloseDialogOpen(true)}
                  isDisabled={!hasCertificate}
                >
                  Appointment Close
                </Button>
              </span>
            </Tooltip>
          )}
        </Flex>
      )}

      <RescheduleAppointment
        appointmentId={Appointment?.id}
        isOpen={isRescheduleOpen}
        onClose={() => setIsRescheduleOpen(false)}
        onSuccess={async () => {
          if (appointmentId) {
            const updated = await appointmentRepository.getappointmentById(appointmentId);
            setAppointment(updated);
          }
        }}
      />

      {centerAlertVisible && (
        <Center
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          zIndex={60}
          pointerEvents="none"
        >
          <Alert
            status={centerAlertStatus}
            variant="solid"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            width="600px"
            borderRadius="14px"
            boxShadow="xl"
            py={10}
            px={16}
            pointerEvents="auto"
          >
            <AlertIcon boxSize="40px" mr={0} />

            <Text fontSize="lg" fontWeight="700" mt={1}>
              {centerAlertMessage}
            </Text>
          </Alert>
        </Center>
      )}

      <AlertDialog
        isOpen={isCloseDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsCloseDialogOpen(false)}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Close Appointment
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? This action will mark the appointment as <strong>Closed</strong>.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsCloseDialogOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleCloseAppointment} ml={3}>
                Yes, Close
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <AlertDialog
        isOpen={isReopenDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsReopenDialogOpen(false)}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Reopen Appointment
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to reopen this appointment?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={() => setIsReopenDialogOpen(false)}>
                Cancel
              </Button>

              <Button
                colorScheme="green"
                ml={3}
                onClick={async () => {
                  await handleReopenAppointment();
                  setIsReopenDialogOpen(false);
                }}
              >
                Yes, Reopen
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

    </Card>
  );
}
